import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider } from 'firebase/app-check';
import { firebaseApp } from './firebaseConfig';

const debugToken = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN as string | undefined;
const recaptchaSiteKey = import.meta.env.VITE_FIREBASE_RECAPTCHA_SITE_KEY as string | undefined;

if (debugToken) {
  // Inject the debug token so the Firebase SDK picks it up automatically
  // @ts-expect-error — global set by Firebase App Check debug provider
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
}

if (recaptchaSiteKey) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (debugToken) {
  // Dev-only: use a no-op custom provider; the debug token injected above does the work
  initializeAppCheck(firebaseApp, {
    provider: new CustomProvider({ getToken: async () => ({ token: debugToken, expireTimeMillis: Date.now() + 3600000 }) }),
    isTokenAutoRefreshEnabled: false,
  });
}
